import React, {Component} from 'react';

import './styles/tooltip.scss';

export default class Tooltip extends Component {

    state = {
        tooltipOpened : false
    }

    openTooltip() {
        this.setState({'tooltipOpened': true})
    }

    closeTooltip() {
      this.setState({'tooltipOpened': false})
    }

    render() {
        const handleClickOutside = (e, id, title) => {
            if (e.target.className !== 'tooltip' && e.target.className !== 'tooltip-toggle' && this.state.tooltipOpened) {
                this.setState({'tooltipOpened': false})
            }
        }

        document.addEventListener('click', handleClickOutside);
        
        const {
            text
        } = this.props;

        return(
          <div className={`tooltip-container`}>
              <div
                className="tooltip-toggle"
                onClick={this.openTooltip.bind(this)}
                onMouseOver={this.openTooltip.bind(this)}
                onMouseLeave={this.closeTooltip.bind(this)}
              />
              <div className={'tooltip ' + (this.state.tooltipOpened ? 'active' : '')}>
                  {text}
              </div>
          </div>
        )
    }
}